module.exports = __webpack_public_path__ + "static/media/Pin_fuel-icon.ae180ab6.svg";